const styles = (theme) => ({
  dialogPaper: {
    width: '100%',
    fontFamily: 'Lato,"Helvetica Neue",Helvetica,Arial,sans-serif',
  },
  dialogHeader: {
    minHeight: '16.43',
    padding: 15,
    fontWeight: 700,
    fontSize: 20,
    textTransform: 'uppercase',
    borderBottom: '1px solid #e5e5e5',
  },
  dialogBody: {
    padding: 20,
  },
  headerTitle: {
    fontWeight: 'bold',
    marginRight: 3,
  },
  odd: {
		backgroundColor: '#f9f9f9',
		
	},
  viewBtn: {
    textTransform: 'none',
    backgroundColor: '#f39c12',
    borderColor: '#f39c12',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#d2850b',
      borderColor: '#be780a',
    },
  },

  // Centered container for download button only
  groupDownloadCenterContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    width: '100%',
  },

  // Centered container for view button in records column
  viewButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
});

export default styles;
